export const environment = {
  production: true,
  // SERVER_API_URL: 'https://api.ethax.trade',

  SERVER_API_URL: 'https://ethax-app-prod.jydq6g27939ct.eu-central-1.cs.amazonlightsail.com',
  GOOGLE_SITE_KEY: '6LdVOVIpAAAAAAIXsIeIflZwHq2E5NlYVbT8rmZP',
};
